import { useAttachments } from 'src/ui/features/attachments/hooks/attachments.hook';
import { useAuthentication } from 'src/ui/features/authentication/hooks/authentication.hook';
import { useOrganisation } from 'src/ui/features/organisation/hooks/organisation.hook';
import { useWorkGroups } from 'src/ui/features/work-groups/hooks/work-groups.hook';
import { Loader } from 'src/ui/shared/components/loader/Loader';
import { useApiConfiguration } from 'src/ui/shared/hooks/api-configuration.hook';
import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';
import { JobDetailsForm, JobDetailsFormProps } from './JobDetailsForm';

type Props = Pick<JobDetailsFormProps, 'job' | 'onCancel' | 'onSaveDraft' | 'onSubmit' | 'state'>;

export const JobDetailsFormWrapper = (props: Props): React.ReactElement => {
    const { isIndividual } = useAuthentication();
    const { isAgentForEmployer, fetch: fetchOrgState } = useOrganisation();
    const defaultWorkGroupId = useRootSelector(state => state.workGroups.queryWorkGroupId);
    const { publishableWorkGroups } = useWorkGroups();
    const { value } = useApiConfiguration();
    const {
        includes: { residencyOptions },
    } = useApiConfiguration();

    const existingAttachments = useAttachments({ type: 'jobs', id: props.job?.id || -1 });

    return (
        <Loader state={fetchOrgState}>
            <JobDetailsForm
                {...props}
                isIndividual={isIndividual}
                isAgentForEmployer={isAgentForEmployer}
                defaultWorkGroupId={defaultWorkGroupId}
                workGroups={publishableWorkGroups}
                residencyOptions={residencyOptions || []}
                disableHideRecruitingFor={!!value?.settings?.disableHideRecruitingFor}
                defaultCurrencyCode={value?.settings?.defaultCurrencyCode}
                attachments={existingAttachments}
            />
        </Loader>
    );
};
